import { render, staticRenderFns } from "./Alertdialog.vue?vue&type=template&id=bbe4316a&"
import script from "./Alertdialog.vue?vue&type=script&lang=js&"
export * from "./Alertdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports